import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { RealEstateDTO, RealEstateOptionsDTO } from '../tables/RealEstate/RealEstate.meta';
import { BusinessAssetDTO, BusinessAssetOptionsDTO } from '../tables/Business/Business.meta';
import { PensionDTO, PensionsOptionsDTO } from '../tables/Pensions/Pensions.meta';
import { MiscAssetDTO, MiscAssetsOptionsDTO } from '../tables/MiscAssets/MiscAssets.meta';
import {
  DeferredCompensationDTO,
  DeferredCompensationOptionsDTO,
} from '../tables/DeferredCompensation/DeferredCompensation.meta';

export const FETCH_OTHER_ASSETS_ENDPOINT = '/Consumer/OtherAssets';

export interface ManagementStylesDTO {
  id: number;
  name: string;
  defaultBucket: number | null;
}

export interface OtherAssetsDTO {
  Assets: {
    RealEstates: RealEstateDTO[];
    BusinessAssets: BusinessAssetDTO[];
    Pensions: PensionDTO[];
    MiscellaneousAssets: MiscAssetDTO[];
    DeferredCompensation: DeferredCompensationDTO[];
  };
  Options: {
    AvailableAssetBuckets: { Title: string }[];
    AllowAssetBucketingCustomization: boolean;
    RealEstateOptions: RealEstateOptionsDTO;
    BusinessAssetOptions: BusinessAssetOptionsDTO;
    PensionOptions: PensionsOptionsDTO;
    MiscellaneousAssetOptions: MiscAssetsOptionsDTO;
    DeferredCompensationOptions: DeferredCompensationOptionsDTO;
    ManagementStyles: ManagementStylesDTO[];
    AssetBucketingByManagementStyle: boolean;
    IsExcludedFromAssetBucketing: boolean;
    DisplayAssetBucketing: boolean;
  };
}

interface FetchParams {
  clientId: string;
}

export const fetchOtherAssets = async ({ clientId }: FetchParams): Promise<OtherAssetsDTO> => {
  return authFetch(urlWithParams(FETCH_OTHER_ASSETS_ENDPOINT, { clientId }));
};

interface QueryParams {
  clientId: string;
}

export const useOtherAssetsQuery = ({ clientId }: QueryParams) => {
  return useQuery(
    queryKeys.otherAssets(clientId),

    () => fetchOtherAssets({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
